import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'




class Footer extends Component {
  render() {
    return (
    <div>
   <footer className="footer pt-80 overlay" >
            <div className="container">
            <div className="row gab_footer">
                <div className="col-md-3">
                <a href="/" >
                            <img className="logotype_footer " src="/assets/img/white_logo.png" alt="Mazel" />
                            </a> <br/>
                                <p className="lieu">Rond Point Cité Keur Gorgui Immeuble El Hadji Fallou LO Dakar - SENEGAL</p>

                            <ul className="social rs">
                            {/*<li><a target="_blank" href="https://twitter.com/Green_Agro_Sn"><i className="fa fa-twitter"></i></a></li>*/}
                            <li><a target="_blank" href="https://www.linkedin.com/company/green-agro-business/about/?viewAsMember=true"><i className="fa fa-linkedin"></i></a></li>
                            <li><a target="_blank" href="https://www.facebook.com/pg/Green-Agro-Business-336091347022906/about/?ref=page_internal"><i className="fa fa-facebook"></i></a></li>

                        </ul>
                </div>


                <div className="col-md-3">
                <h2>Green Agro Business</h2>
                            <ul className="link">
                                {/*<li><a href="/mot-du-president">Mot du président</a></li>*/}
                                <li><a href="/qui-sommes-nous">Qui sommes-nous?</a></li>
                                <li><a href="/notre-usine">Notre usine</a></li>
                                {/*<li><a href="/notre-equipe">Notre équipe</a></li>*/}
                                <li><a href="nos-engagements"> Nos engagements</a></li>
                                <li><a href="rse">Nos réalisations RSE</a></li>

                            </ul>
                            <h2>Nos Partenaires</h2>
                            <ul className="link">
                                <li><a href="/nos-partenaires">Ils nous font confiance</a></li>
                            </ul>
                </div>
                <div className="col-md-3">
                <h2>Nos Produits</h2>
                        <ul className="link">
                            <li><a href="/produits/teranga"><img src="/assets/img/logos/teranga.png" className="teranga_img"/></a></li>
                            <li className="terangaplus"><a href="/produits/teranga-plus"><img src="/assets/img/logos/terangaplus.png" className="terangaplus_img"/></a></li>
                            {/*<li><a href="/certification-bio">Certification Bio</a></li>*/}
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    <h2 className="recru">Recrutement</h2>
                        <ul className="link">
                            <li><a href="/recrutement">Nos offres d'emplois</a></li>

                        </ul>



                </div>
                <div className="col-md-3">
                <h2 className="serv_footer">Nos Services</h2>
                        <ul className="link">
                            <li><a href="/technicien-conseil">Techniciens conseils</a></li>
                            <li><a href="/recherche-et-innovation"> Recherche & innovation</a></li>
                            {/*<li><a href="/notre-equipe">Notre equipe</a></li>*/}
                        </ul>
                        <div className="located">
                         <h2 className="adress_footer">Nous contacter</h2>
                                <ul className="link-small">
                                    <li><a className="lowercase" href="mailto:contact@greenagrobusiness.com"><i className="fa fa-envelope"></i>contact@greenagrobusiness.com</a></li>
                                    <li><a><i className="fa fa-phone left"></i>+221 33 825 74 44</a></li>
                                </ul>

                        </div>
                    </div>


            </div>
    </div>





            <section className="copyright">
                <div className="container">
                    <p className="">
                        ©2018,<a href="/"><b className="copi" >Green Agro Business</b></a>. Tous droits réservés.
                        <br />

                    </p>
                </div>
            </section>


        </footer>

    </div>



    )
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.jsx